export function preloadImage(src: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(src);
    img.onerror = () => reject(new Error(`failed: ${src}`));
    img.src = src;
  });
}

export async function preloadAll(srcs: string[]): Promise<string[]> {
  const results = await Promise.allSettled(srcs.map(preloadImage));
  return results
    .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
    .map((r) => r.value);
}
